import { Injectable } from '@angular/core';
import { GetTimestampFromTime } from '@dave/types';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';
import { concatMap } from 'rxjs/internal/operators/concatMap';
import { map, switchMap } from 'rxjs/operators';
import { uniqArray } from '../../../helper/helper';
import { MaterialAmountEntityFromBackend } from '../../entities/material-amount.entity';
import { WarehouseMovementEntityFromBackend } from '../../entities/warehouseMovement.entity';
import { AppGatewayService } from '../../services/app-gateway.service';
import { MaterialDataService } from '../../services/material-data.service';
import { DaveActions } from '../actions/actions';
import { BaseActionTypes } from '../actions/base.actions';
import { MaterialAmountActionTypes } from '../actions/material-amount.actions';
import { WarehouseMovementActionTypes } from '../actions/warehouse-movement.actions';
import { State } from '../index';
import { getMaterialAmountDictionary } from '../selectors/material-amount.selectors';

enum ErrorCodes {
    Load = 'WarehouseMovement abrufen fehlgeschlagen',
    Add = 'WarehouseMovement anlegen fehlgeschlagen',
}

@Injectable()
export class WarehouseMovementEffects {
    constructor(private actions$: Actions<DaveActions>, private store$: Store<State>, private gatewayService: AppGatewayService, private materialDataService: MaterialDataService) {}

    LoadWarehouseMovement$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(WarehouseMovementActionTypes.LoadRequest),
                switchMap(({ Payload }) => {
                    return this.gatewayService
                        .Request({ ErpWarehouseMovementGet: Payload })
                        .then((res) => {
                            if (Object.keys(res?.Errors || {}).length === 0) {
                                firstValueFrom(this.store$.select(getMaterialAmountDictionary)).then((MaterialAmounts) => {
                                    const fRes = res.ErpWarehouseMovementGet.WarehouseMovements.filter((WarehouseMovement) => {
                                        const fromState = MaterialAmounts[WarehouseMovement.Id];
                                        return !fromState || GetTimestampFromTime(fromState.CreatedAt).toString() !== WarehouseMovement.CreatedAt;
                                    });
                                    if (fRes.length) {
                                        this.store$.dispatch(
                                            WarehouseMovementActionTypes.UpdateMany({
                                                Payload: fRes.map((val) => WarehouseMovementEntityFromBackend(val)),
                                                updateLatestUpdatedAt: true,
                                            }),
                                        );
                                    }
                                });
                            } else {
                                throw res.Errors;
                            }
                        })
                        .catch((err) => {
                            this.store$.dispatch(
                                BaseActionTypes.ErrorAction({
                                    Payload: {
                                        ToasterMessage: ErrorCodes.Load,
                                        Err: err,
                                    },
                                }),
                            );
                            // return EMPTY;
                        });
                }),
            );
        },
        { dispatch: false },
    );
    AddWareHouseMoveMent$ = createEffect(() =>
        this.actions$.pipe(
            ofType(WarehouseMovementActionTypes.CreateRequest),
            concatMap(({ Payload }) =>
                this.gatewayService
                    .Request({ ErpWarehouseMovementCreate: Payload })
                    .then((res) => {
                        if (Object.keys(res?.Errors || {}).length === 0) {
                            if (!res.ErpWarehouseMovementCreate?.WarehouseMovement) {
                                throw 'wrong response ErpWarehouseMovementCreate';
                            }
                            this.store$.dispatch(MaterialAmountActionTypes.UpdateMany({ Payload: (res.ErpWarehouseMovementCreate.WarehouseMovement.Amounts || []).map(MaterialAmountEntityFromBackend) }));
                            this.materialDataService.reloadCache(uniqArray((res.ErpWarehouseMovementCreate.WarehouseMovement.Amounts || []).map((a) => Number(a.MaterialId))));
                            return WarehouseMovementActionTypes.CreateSuccess({ Payload: WarehouseMovementEntityFromBackend(res.ErpWarehouseMovementCreate.WarehouseMovement) });
                        } else {
                            throw res.Errors;
                        }
                    })
                    .catch((err) =>
                        WarehouseMovementActionTypes.CreateFailure({
                            Payload: {
                                ToasterMessage: ErrorCodes.Add,
                                Errors: err,
                            },
                        }),
                    ),
            ),
        ),
    );
    error$ = createEffect(() =>
        this.actions$.pipe(
            ofType(WarehouseMovementActionTypes.LoadFailure, WarehouseMovementActionTypes.ChangeFailure, WarehouseMovementActionTypes.CreateFailure),
            map(({ Payload }) =>
                BaseActionTypes.ErrorAction({
                    Payload: {
                        ToasterMessage: Payload.ToasterMessage,
                        Err: Payload.Errors,
                    },
                }),
            ),
        ),
    );
}
